import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const kontrolaService = {
    load,loadAll,loadLastYear,save,remove,loadOne,saveOne,loadZaDodeljevanje,dodeliKontrole
    
};

function load(sezona,pridelovalecid,shema) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}/${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}


function loadOne(sezona,pridelovalecid,shema,kontrolaid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}/${pridelovalecid}/${kontrolaid}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}

function saveOne(kontrola,sezona,pridelovalecid,shema,kontrolaid) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrola)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}/${pridelovalecid}/${kontrolaid}`, requestOptions).then(handleResponse);
}


function dodeliKontrole(sezona, shema,kontrole) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrole)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/dodelikontrole/${shema}/${sezona}/`, requestOptions).then(handleResponse);
}

function save(kontrola,sezona,pridelovalecid,shema) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrola)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}/${pridelovalecid}`, requestOptions).then(handleResponse);
}


function remove(kontrola,sezona,pridelovalecid,shema) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kontrola)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}/${pridelovalecid}`, requestOptions).then(handleResponse);
}

function loadAll(sezona,shema){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/${shema}/${sezona}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });
}

function loadZaDodeljevanje(sezona,shema){
    const requestOptions = {
          method: 'GET',
          headers:authHeader(),
          
      };
  
  
       return fetch(`${Vue.prototype.$config.apiUrl}/kontrola/dodajanje/${shema}/${sezona}`, requestOptions)
          .then(handleResponse)
          .then(kontrola => {
              // login successful if there's a jwt token in the response
              
              return kontrola;
          });
  }

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/kontrola/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kontrola => {
            // login successful if there's a jwt token in the response
            
            return kontrola;
        });

}
